// extracted by mini-css-extract-plugin
export default {"root":"U7E3y","amount":"djuNT","expireDate":"WwFU3","expireDatetime":"YhlY5"};